import Modal from 'react-bootstrap/Modal';
import { Button } from 'reactstrap';
import React, { Component } from 'react';
import { Badge, Label, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import { connect } from "react-redux";
import '../../Modals.scss';
import ethereum from 'decentralized/ethereum.js';

/**
 * Modal responsible for sequence-wide changes like
 * double setting the track length
 */
class DMCAModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            emailAddress: '',
            reasoning: '',
        };

        this.onClickDone = this.onClickDone.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
    }

    onClickDone() {
        ethereum.dmca.copyStrikeSample(
            this.props.sampleHash,
            this.state.emailAddress,
            this.state.reasoning);
        this.props.hide();
    }

    onClickCancel() {
        this.props.hide();
    }

    render() {
        return (
            <Modal dialogClassName="preset-modal" show={this.props.show} onHide={this.onClickCancel}>
              <Modal.Header closeButton>
                <Modal.Title>DMCA Takedown Form</Modal.Title>
              </Modal.Header>
              <Modal.Body>
               Provide proof that you own the rights to this sample here, or email us at universalsequences@gmail.com with the sound identifier:
                <div className="sample-identifier">{this.props.sampleHash}</div>
                <InputGroup>
                  <label>Email Address: </label>
                  <Input
                    onChange={(event) => this.setState({emailAddress: event.target.value})}
                    value={this.state.emailAddress}
                    placeholder="Enter your email address" className="email-address-input"/>
                </InputGroup>
                <InputGroup>
                  <Input
                    onChange={(event) => this.setState({reasoning: event.target.value})}
                    value={this.state.reasoning}
                    type="textarea"
                    placeholder="Include proof here of your rights to this sound and other shit" className="dmca-reasoning-input"/>
                </InputGroup>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={this.onClickDone}>
                  Done
                </Button>
                <Button variant="primary" onClick={this.onClickCancel}>
                  Cancel
                </Button>
              </Modal.Footer>
            </Modal>
        );
    }
}
const mapDispatchToProps = dispatch => {
    return {
    }
};

const mapStateToProps = state => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DMCAModal);
